import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";
import { ZbsInvoiceCreation } from '../Ebootis.Shared/ZbsInvoiceCreation';

@Injectable({providedIn: 'root'})
export class Configuration
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(params: Configuration.Params): Observable<Configuration.Result>
	{
		return this.m_queryInvoker.doQuery("Configuration", params);
	}
};

export namespace Configuration
{
	export class Params
	{
		oid: string;
	};
	export interface Result
	{
		verificationCode?: string;
		oid?: string;
		name?: string;
		authAmount?: number;
		userOid?: string;
		userName?: string;
		userCostCenter?: string;
		companyOid?: string;
		currencyCode?: string;
		currencySymbol?: string;
		valuelistEnabled?: boolean;
		valuelistMandatory?: boolean;
		accessAllAddresses?: boolean;
		maintainAllAddresses?: boolean;
		invoiceCreation?: ZbsInvoiceCreation;
		onlyAvailableStock?: boolean;
		showProcPrice?: boolean;
		showStockLevel?: boolean;
		showReservedStock?: boolean;
		showSubPackaging?: boolean;
		showStoragePackaging?: boolean;
		showSalesPrice?: boolean;
		showBackOrder?: boolean;
		showMinStock?: boolean;
		showAvailableStock?: boolean;
		showReplacementTime?: boolean;
		showEAN?: boolean;
		showCategory?: boolean;
		showArticleGroup?: boolean;
		showDepartment?: boolean;
		showInfo1?: boolean;
		showInfo2?: boolean;
		showInfo3?: boolean;
		showInfo4?: boolean;
		showInfo5?: boolean;
		showInfo6?: boolean;
		budgetAdminAllowed?: boolean;
		hasAuthorizationRole?: boolean;
		isSetCostCenterAllowed?: boolean;
		campaignPhase1Allowed?: boolean;
		campaignPhase2Allowed?: boolean;
		showSpecialOrder?: boolean;
		noInvoiceWithoutValue?: boolean;
		showFixDate?: boolean;
		minFixDateDayOffset?: number;
		txDefOrder?: TxDefOrder;
		txDefCampaign?: TxDefCampaign;
		attr1?: Attr1;
		attr2?: Attr2;
		helpDoc?: HelpDoc;
		imprint?: Imprint;
		stylesheet?: Stylesheet;
		logo?: Logo;
		attr3?: Attr3;
	};
	export interface TxDefOrder
	{
		oid?: string;
		name?: string;
		descr?: string;
	};
	export interface TxDefCampaign
	{
		oid?: string;
		name?: string;
		descr?: string;
	};
	export interface Attr1
	{
		oid?: string;
		name?: string;
	};
	export interface Attr2
	{
		oid?: string;
		name?: string;
	};
	export interface HelpDoc
	{
		oid?: string;
		displayName?: string;
	};
	export interface Imprint
	{
		oid?: string;
		displayName?: string;
	};
	export interface Stylesheet
	{
		oid?: string;
		displayName?: string;
	};
	export interface Logo
	{
		oid?: string;
		displayName?: string;
	};
	export interface Attr3
	{
		oid?: string;
		name?: string;
	};
};
